import React, { useEffect } from "react";
import "./terms.scss";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

const SECTIONS = [
  {
    title: "1. Who we are and acceptance of these Terms",
    paragraphs: [
      'These Terms and Conditions (the "Terms") govern your access to and use of the website available at mezada.net, including its subdomains and any content, features, and services offered through it (collectively, the "Site"). The Site is owned and operated by Mezada Development and Software LTD, a company incorporated under the laws of the State of Israel, company registration number 515306199, with its registered office at Shvil Hameretz 4, Tel Aviv ("Mezada", "we", "us", or "our").',
      "By accessing or using the Site, you confirm that you have read, understood, and agree to be bound by these Terms and by our Privacy Policy, which is incorporated into these Terms by reference. If you do not agree to these Terms, please do not use the Site.",
    ],
  },
  {
    title: "2. The Site is informational",
    paragraphs: [
      "The Site presents general information about Mezada, our areas of expertise, and our products. All content on the Site is provided for general informational purposes only. It does not constitute professional, technical, legal, or financial advice, and it does not constitute an offer, a quotation, or a binding commitment of any kind. We may modify, suspend, or discontinue the Site, or any part of it, at any time and without notice.",
    ],
  },
  {
    title: "3. Relationship to the Joni product",
    paragraphs: [
      "Joni is a product of Mezada Development and Software LTD, available at joni.ai. Access to and use of Joni are governed exclusively by Joni’s own terms of service and privacy policy, which are separate from these Terms. Nothing on this Site grants you any right or license to use Joni, and no statement on this Site modifies or supplements the terms that govern the Joni product.",
    ],
  },
  {
    title: "4. Permitted use of the Site",
    paragraphs: [
      "You may use the Site only for lawful purposes and in accordance with these Terms. Without limiting the foregoing, you agree not to: (a) interfere with or disrupt the operation, security, or availability of the Site; (b) attempt to gain unauthorized access to the Site, its servers, or any connected systems; (c) use any robot, spider, scraper, or other automated means to access or harvest content or data from the Site without our prior written consent; (d) introduce viruses, malware, or any other harmful code; (e) use the Site in a manner that infringes the rights of Mezada or of any third party; or (f) impersonate any person or entity or misrepresent your affiliation with any person or entity.",
    ],
  },
  {
    title: "5. Intellectual property",
    paragraphs: [
      'The Site and all of its content, including text, graphics, logos, icons, images, page layouts, designs, and underlying software, are the property of Mezada or its licensors and are protected by the intellectual property laws of the State of Israel and other jurisdictions. "Mezada", "Joni", and the associated logos are trademarks of Mezada Development and Software LTD. All rights not expressly granted in these Terms are reserved.',
      "Subject to your compliance with these Terms, we grant you a limited, revocable, non-exclusive, non-transferable license to access and view the Site for your personal or internal business informational purposes. You may not copy, reproduce, distribute, modify, create derivative works from, publicly display, or otherwise exploit any content on the Site without our prior written consent.",
    ],
  },
  {
    title: "6. Contact form and communications",
    paragraphs: [
      "If you submit information through the contact form on the Site (such as your name, email address, phone number, or the content of your message), that information will be processed in accordance with our Privacy Policy. Submitting an inquiry does not create a client, engagement, or confidential relationship between you and Mezada. Any engagement with Mezada is established only through a separately signed written agreement. Please do not send us confidential or proprietary information through the Site.",
    ],
  },
  {
    title: "7. Third-party links",
    paragraphs: [
      "The Site may contain links to third-party websites or services that are not owned or controlled by Mezada. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services. The inclusion of a link does not imply endorsement by Mezada.",
    ],
  },
  {
    title: "8. Disclaimer of warranties",
    paragraphs: [
      'The Site is provided on an "as is" and "as available" basis, without warranties of any kind, whether express or implied, including, without limitation, implied warranties of merchantability, fitness for a particular purpose, non-infringement, accuracy, or availability. Mezada does not warrant that the Site will be uninterrupted, timely, secure, or error-free, or that any information on the Site is complete, accurate, or up to date.',
    ],
  },
  {
    title: "9. Limitation of liability",
    paragraphs: [
      "To the maximum extent permitted by applicable law, Mezada, its directors, officers, employees, and agents shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or for any loss of profits, revenue, data, or goodwill, arising out of or in connection with your use of, or inability to use, the Site, even if Mezada has been advised of the possibility of such damages. To the maximum extent permitted by applicable law, Mezada’s aggregate liability arising out of or relating to the Site or these Terms shall not exceed USD 100. Nothing in these Terms excludes or limits any liability that cannot be excluded or limited under applicable law.",
    ],
  },
  {
    title: "10. Indemnification",
    paragraphs: [
      "You agree to indemnify, defend, and hold harmless Mezada and its directors, officers, employees, and agents from and against any claims, liabilities, damages, losses, and expenses, including reasonable legal fees, arising out of or in any way connected with your breach of these Terms or your misuse of the Site.",
    ],
  },
  {
    title: "11. Changes to these Terms",
    paragraphs: [
      'We may update these Terms from time to time. The updated version will be posted on this page with a revised "Last updated" date, and it will take effect upon posting. Your continued use of the Site after an update constitutes your acceptance of the updated Terms. We encourage you to review this page periodically.',
    ],
  },
  {
    title: "12. Governing law and jurisdiction",
    paragraphs: [
      "These Terms, and any dispute or claim arising out of or in connection with them or the Site, shall be governed by and construed in accordance with the laws of the State of Israel, without regard to its conflict-of-law rules. The competent courts of Tel Aviv-Yafo, Israel shall have exclusive jurisdiction over any such dispute or claim.",
    ],
  },
  {
    title: "13. General provisions",
    paragraphs: [
      "If any provision of these Terms is held to be invalid or unenforceable, that provision shall be enforced to the maximum extent permissible and the remaining provisions shall remain in full force and effect. No failure or delay by Mezada in exercising any right under these Terms shall operate as a waiver of that right. You may not assign your rights or obligations under these Terms without our prior written consent; we may assign our rights and obligations without restriction. These Terms, together with the Privacy Policy, constitute the entire agreement between you and Mezada regarding the use of the Site. Section headings are for convenience only.",
    ],
  },
  {
    title: "14. Contact",
    paragraphs: [
      "Questions about these Terms can be sent to info@mezada.net.",
    ],
  },
];

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <main className="mz-legal">
        <div className="mz-legal__header">
          <p className="mz-legal__kicker">LEGAL</p>
          <h1 className="mz-legal__title">Terms & Conditions</h1>
          <p className="mz-legal__updated">LAST UPDATED · Aug 25, 2026</p>
        </div>
        <div className="mz-legal__body">
          {SECTIONS.map((section) => (
            <section key={section.title} className="mz-legal__section">
              <h2>{section.title}</h2>
              {section.paragraphs.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Terms;
